module.exports = __webpack_public_path__ + "media/packs/images/pci-logo-8f156bf4efe05fd08794d089feb47236.png";